import React, { useEffect, useState, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
  VALIDATOR_NUMBER_ONLY,
} from "../../shared/util/validators";
import useForm from "../../shared/hooks/form-hooks";
import { useSelector, useDispatch } from "react-redux";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import { AuthContext } from "../../context/AuthContext";
import { CircularProgress } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useSnackbar } from "notistack";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import { Checkbox, FormControlLabel } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const NewOrderForm = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [orderTypes, setOrderTypes] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [process, setProcess] = useState();
  const [addedTime, setAddedTime] = useState(0);
  const [predictionDate, setPredictionDate] = useState(
    jMoment().startOf("day")
  );
  const [wait, setWait] = useState(false);
  const waitHandler = (event) => {
    setWait(event.target.checked);
  };
  const [startDate, setStartDate] = useState(jMoment().startOf("day"));
  jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

  const [mount, setMount] = useState(true);

  const [boxNumberCheckpoint, setBoxNumberCheckpoint] = useState("");
  const [open2, setOpen2] = useState(false);
  const [savedFormState, setSavedFormState] = useState(null); // New state variable to save form state

  const handleOpen2 = (formState) => {
    setSavedFormState(formState); // Save the form state when opening the modal
    setOpen2(true);
  };
  const handleClose2 = () => setOpen2(false);
  //initializing the inputs
  const [formState, inputHandler] = useForm(
    {
      patientName: {
        value: "",
        isValid: false,
      },
      doctorName: {
        value: "",
        isValid: false,
      },
      boxNumber: {
        value: "",
        isValid: true,
      },
      orderNumber: {
        value: "",
        isValid: true,
      },
      orderType: {
        value: "",
        isValid: false,
      },
      unitCount: {
        value: "",
        isValid: false,
      },
      jawCount: {
        value: "",
        isValid: false,
      },
      upRight: {
        value: "",
        isValid: true,
      },
      upLeft: {
        value: "",
        isValid: true,
      },
      downRight: {
        value: "",
        isValid: true,
      },
      downLeft: {
        value: "",
        isValid: true,
      },
      description: {
        value: "",
        isvalid: true,
      },
      tasks: {
        value: [],
        isvalid: true,
      },
    },
    false
  );

  //sending the order submit request
  // const orderSubmitHandler = async (event) => {
  //   event.preventDefault();
  //   let processIds = [];
  //   for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
  //     processIds.push(formState.inputs.tasks.value[i].id);
  //   }
  //   setIsLoading(true);
  //   setMount(false);

  //   axios
  //     .post(
  //       "/api/v1/laboratorys/check-boxNumber",
  //       {
  //         boxNumber: formState.inputs.boxNumber.value,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           authorization: auth.token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.data.existence == true) {
  //         axios
  //           .post(
  //             "/api/v1/laboratorys/create-order",
  //             {
  //               patiantName: formState.inputs.patientName.value,
  //               boxNumber: formState.inputs.boxNumber.value,
  //               doctorLabId: formState.inputs.doctorName.value.id,
  //               orderTypeId: formState.inputs.orderType.value.id,
  //               jawCount: formState.inputs.jawCount.value,
  //               unitCount: formState.inputs.unitCount.value.units,
  //               upRight: formState.inputs.upRight.value,
  //               upLeft: formState.inputs.upLeft.value,
  //               downLeft: formState.inputs.downLeft.value,
  //               downRight: formState.inputs.downRight.value,
  //               startDate: new Date(startDate).getTime(),
  //               predictionDate: wait
  //                 ? null
  //                 : new Date(predictionDate).getTime(),
  //               description: formState.inputs.description.value,
  //               processIds: processIds,
  //               entryDescription: formState.inputs.description.value,
  //               exitDescription: "",
  //             },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 authorization: auth.token,
  //               },
  //             }
  //           )
  //           .then((response) => {
  //             console.log("Form submitted successfully");
  //             enqueueSnackbar(response.data.message.message, {
  //               variant: "success",
  //             });
  //             setIsLoading(false);
  //             setMount(true);
  //           })
  //           .catch((e) => {
  //             const messages =
  //               e.response.data.data.length > 0
  //                 ? e.response.data.data
  //                 : e.response.data.message.message;

  //             Array.isArray(messages)
  //               ? messages.map((message) => {
  //                   enqueueSnackbar(message, { variant: "error" });
  //                 })
  //               : enqueueSnackbar(messages, { variant: "error" });
  //             setIsLoading(false);
  //             setMount(true);
  //           });
  //       } else {
  //         console.log("open modal ...");
  //         setBoxNumberCheckpoint(formState.inputs.boxNumber.value);
  //         setIsLoading(false);
  //         setMount(true);
  //         handleOpen2();
  //         // console.log(formState.inputs.boxNumber.value);
  //       }
  //     })
  //     .catch((e) => {
  //       const messages =
  //         e.response.data.data.length > 0
  //           ? e.response.data.data
  //           : e.response.data.message.message;

  //       Array.isArray(messages)
  //         ? messages.map((message) => {
  //             enqueueSnackbar(message, { variant: "error" });
  //           })
  //         : enqueueSnackbar(messages, { variant: "error" });
  //       setIsLoading(false);
  //       setMount(true);
  //     });
  // };

  // The new order submit handler
  const orderSubmitHandlerThird = async (
    event,
    runCheckBoxNumber = true,
    formState
  ) => {
    event.preventDefault();
    let processIds = [];
    for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
      processIds.push(formState.inputs.tasks.value[i].id);
    }
    setIsLoading(true);
    setMount(false);

    if (runCheckBoxNumber) {
      axios
        .post(
          "/api/v1/laboratorys/check-boxNumber",
          {
            boxNumber: formState.inputs.boxNumber.value,
          },
          {
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
          }
        )
        .then((response) => {
          if (response.data.data.existence == true) {
            createOrder(processIds, formState);
          } else {
            console.log("open modal ...");
            setBoxNumberCheckpoint(formState.inputs.boxNumber.value);
            setIsLoading(false);
            setMount(true);
            handleOpen2(formState); // Pass formState to handleOpen2
          }
        })
        .catch((e) => {
          handleError(e);
        });
    } else {
      createOrder(processIds, formState);
    }
  };

  const createOrder = (processIds, formState) => {
    axios
      .post(
        "/api/v1/laboratorys/create-order",
        {
          patiantName: formState.inputs.patientName.value,
          boxNumber: formState.inputs.boxNumber.value,
          doctorLabId: formState.inputs.doctorName.value.id,
          orderTypeId: formState.inputs.orderType.value.id,
          jawCount: formState.inputs.jawCount.value,
          unitCount: formState.inputs.unitCount.value.units,
          upRight: formState.inputs.upRight.value,
          upLeft: formState.inputs.upLeft.value,
          downLeft: formState.inputs.downLeft.value,
          downRight: formState.inputs.downRight.value,
          startDate: new Date(startDate).getTime(),
          predictionDate: wait ? null : new Date(predictionDate).getTime(),
          description: formState.inputs.description.value,
          processIds: processIds,
          entryDescription: formState.inputs.description.value,
          exitDescription: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        console.log("Form submitted successfully");
        enqueueSnackbar(response.data.message.message, {
          variant: "success",
        });
        setIsLoading(false);
        setMount(true);
      })
      .catch((e) => {
        handleError(e);
      });
  };

  const handleError = (e) => {
    const messages =
      e.response.data.data.length > 0
        ? e.response.data.data
        : e.response.data.message.message;

    Array.isArray(messages)
      ? messages.map((message) => {
          enqueueSnackbar(message, { variant: "error" });
        })
      : enqueueSnackbar(messages, { variant: "error" });
    setIsLoading(false);
    setMount(true);
  };

  //defining the instances
  const UNITS = [
    { units: "1", types: 1 },
    { units: "2", types: 1 },
    { units: "3", types: 1 },
    { units: "4", types: 1 },
    { units: "5", types: 1 },
    { units: "6", types: 1 },
    { units: "7", types: 1 },
    { units: "8", types: 2 },
    { units: "9", types: 2 },
    { units: "10", types: 2 },
    { units: "12", types: 2 },
    { units: "13", types: 2 },
    { units: "14", types: 2 },
    { units: "15", types: 3 },
    { units: "16", types: 3 },
    { units: "17", types: 3 },
    { units: "18", types: 3 },
    { units: "19", types: 3 },
    { units: "20", types: 3 },
    { units: "21", types: 3 },
    { units: "22", types: 4 },
    { units: "23", types: 4 },
    { units: "24", types: 4 },
    { units: "25", types: 4 },
    { units: "26", types: 4 },
    { units: "27", types: 4 },
    { units: "28", types: 4 },
    { units: "نامشخص", types: 5 },
    { units: "فک یالا", types: 5 },
    { units: "فک پایین", types: 5 },
  ];
  const JAWS = ["یک فک", "دو فک"];

  //setting added time
  useEffect(() => {
    if (
      formState.inputs.jawCount.value &&
      formState.inputs.unitCount.value &&
      formState.inputs.orderType.value &&
      formState.inputs.tasks.value
    ) {
      switch (formState.inputs.jawCount.value) {
        case "یک فک":
          switch (formState.inputs.unitCount.value.types) {
            case 1:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].oneJaw1To7)
                );
                console.log(addedTime);
              }
              break;
            case 2:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].oneJaw7To14)
                );
              }

              break;
            case 3:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw14To21)
                );
              }
              break;
            case 4:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw21To28)
                );
              }

              break;
            case 5:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].oneJawFull)
                );
              }
              break;
            default:
              break;
          }
          break;
        case "دو فک":
          switch (formState.inputs.unitCount.value.types) {
            case 1:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw1To7)
                );
              }
              break;
            case 2:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw7To14)
                );
              }
              break;
            case 3:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw14To21)
                );
              }
              break;
            case 4:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJaw21To28)
                );
              }
              break;
            case 5:
              setAddedTime(0);
              for (let i = 0; i < formState.inputs.tasks.value.length; i += 1) {
                setAddedTime(
                  (prevState) =>
                    prevState +
                    Number(formState.inputs.tasks.value[i].twoJawFull)
                );
              }
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    }
  }, [
    formState.inputs.jawCount.value,
    formState.inputs.unitCount.value,
    formState.inputs.orderType.value,
    formState.inputs.tasks.value,
    startDate,
  ]);

  // getting orderTypes
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-orderTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 0,
              rowCount: 0,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setOrderTypes(responseData.data.result);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //getting doctor names
  useEffect(() => {
    async function sendRequest() {
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/laboratorys/get-doctors`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
            body: JSON.stringify({
              onlyName: true,
              page: 1,
            }),
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setDoctorNames(responseData.data.result);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //getting order process and timing
  useEffect(() => {
    async function sendRequest() {
      if (formState.inputs.orderType.value) {
        setIsLoading(true);
        try {
          const response = await fetch(
            baseUrl + `/api/v1/laboratorys/get-orderType-process`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: auth.token,
              },
              body: JSON.stringify({
                orderTypeId: formState.inputs.orderType.value.id.toString(),
              }),
            }
          );
          const responseData = await response.json();
          if (!response.ok) {
            setIsLoading(false);
            // Handle error based on responseData structure
            if (responseData.message && responseData.data) {
              const messages = responseData.message;
              if (Array.isArray(messages)) {
                messages.forEach((message) => {
                  enqueueSnackbar(message, { variant: "error" });
                });
              } else {
                enqueueSnackbar(responseData.message.message, {
                  variant: "error",
                });
              }
            } else {
              throw new Error("An unexpected error occurred");
            }
          }
          setProcess(responseData.data);
        } catch (err) {
          err &&
            err.data.map((error) => {
              enqueueSnackbar(error, { variant: "error" });
            });
        }
        setIsLoading(false);
      }
    }

    sendRequest();
  }, [formState.inputs.orderType.value]);

  //set prediction date
  useEffect(() => {
    // i had to convert it to dateTime object because the component accepts DateTime
    setPredictionDate(new Date(Number(startDate) + addedTime * 86400000));
  }, [addedTime]);

  //test
  // useEffect(() => {
  // 	console.log(formState.inputs);
  // }, [mount]);

  const clearHandler = () => {
    //resetForm();
    setMount((prev) => !prev);
  };

  return (
    <React.Fragment>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
        <div>
          <Modal open={open2} onClose={handleClose2}>
            <Box sx={style}>
              <Typography variant="h6" component="h2">
                {boxNumberCheckpoint}
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                شماره جعبه تکراری می باشد.
                <br /> آیا مطمئنید که می خواهد این سفارش را ثبت کنید ؟
              </Typography>

              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid xs={6}>
                  <Button
                    fullWidth
                    color="error"
                    variant="contained"
                    onClick={(event) => {
                      orderSubmitHandlerThird(event, false, savedFormState);
                      handleClose2();
                    }}
                  >
                    بله
                  </Button>
                </Grid>
                <Grid xs={6}>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={handleClose2}
                  >
                    خیر
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </div>
        <Typography variant="h5" align="center" sx={{ mb: 5 }}>
          سفارش جدید
        </Typography>
        {!mount ? (
          <CircularProgress color="inherit" />
        ) : (
          <form
            onSubmit={(event) =>
              orderSubmitHandlerThird(event, true, formState)
            }
          >
            <Grid container spacing={2}>
              <Grid md={6} xs={12}>
                <Input
                  id="patientName"
                  element="input"
                  label="نام بیمار"
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText="لطفا نام بیمار را وارد کنید."
                  onInput={inputHandler}
                />
              </Grid>
              <Grid md={6} xs={12}>
                <Input
                  id="doctorName"
                  element="autoComplete"
                  label="نام پزشک"
                  validators={[VALIDATOR_AUTOCOMPLETE()]}
                  errorText="لطفا نام دکتر را انتخاب کنید."
                  onInput={inputHandler}
                  options={doctorNames}
                  getOptionLabel={(option) => option.name}
                  required={true}
                  inputValid={false}
                />
              </Grid>
              <Grid md={6} xs={12}>
                <Input
                  id="boxNumber"
                  element="input"
                  label="شماره جعبه"
                  validators={[VALIDATOR_VALIDATED()]}
                  errorText="لطفا شماره جعبه را وارد نمایید."
                  onInput={inputHandler}
                  inputValid={true}
                />
              </Grid>
              <Grid md={6} xs={12}>
                <Input
                  id="orderType"
                  element="autoComplete"
                  label="نوع کار"
                  validators={[VALIDATOR_AUTOCOMPLETE()]}
                  errorText="لطفا نوع کار را انتخاب کنید."
                  onInput={inputHandler}
                  options={orderTypes}
                  getOptionLabel={(option) => option.name}
                  required={true}
                  inputValid={false}
                />
              </Grid>
              <Grid md={12}>
                <hr />
              </Grid>
              <Grid md={6} xs={12}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterJalaali}>
                    <DatePicker
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      // disableFuture={true}
                      label="تاریخ شروع"
                      disableMaskedInput
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size={"medium"}
                          variant={"outlined"}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="unitCount"
                  element="autoComplete"
                  label="تعداد واحد"
                  validators={[VALIDATOR_AUTOCOMPLETE()]}
                  errorText="لطفا تعداد واحد را انتخاب کنید."
                  onInput={inputHandler}
                  options={UNITS}
                  getOptionLabel={(unit) => unit.units}
                  required={true}
                  inputValid={false}
                />
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="jawCount"
                  element="autoComplete"
                  label="تعداد فک"
                  validators={[VALIDATOR_AUTOCOMPLETE()]}
                  errorText="لطفا تعداد فک را انتخاب کنید."
                  onInput={inputHandler}
                  options={JAWS}
                  getOptionLabel={(jaw) => jaw}
                  required={true}
                  inputValid={false}
                />
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="upRight"
                  element="number_only"
                  label="شماره دندان (فک بالا راست)"
                  validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                  errorText="لطفا فقط عدد وارد کنید."
                  onInput={inputHandler}
                  inputValid={true}
                  inputProps={{ min: 1, max: 8 }}
                />
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="upLeft"
                  element="number_only"
                  label="شماره دندان (فک بالا چپ)"
                  validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                  errorText="لطفا فقط عدد وارد کنید."
                  onInput={inputHandler}
                  inputValid={true}
                  inputProps={{ min: 1, max: 8 }}
                />
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="downRight"
                  element="number_only"
                  label="شماره دندان (فک پایین راست)"
                  validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                  errorText="لطفا فقط عدد وارد کنید."
                  onInput={inputHandler}
                  inputValid={true}
                  inputProps={{ min: 1, max: 8 }}
                />
              </Grid>
              <Grid md={3} xs={6}>
                <Input
                  id="downLeft"
                  element="number_only"
                  label="شماره دندان (فک پایین چپ)"
                  validators={[VALIDATOR_VALIDATED(), VALIDATOR_NUMBER_ONLY()]}
                  errorText="لطفا فقط عدد وارد کنید."
                  onInput={inputHandler}
                  inputValid={true}
                  inputProps={{ min: 1, max: 8 }}
                />
              </Grid>
              <Grid md={12}>
                <hr />
              </Grid>
              <Grid md={6} xs={12}>
                <Input
                  id="tasks"
                  element="select"
                  validators={[VALIDATOR_SELECT()]}
                  errorText="لطفا عملیات را انتخاب کنید."
                  multiline={true}
                  onInput={inputHandler}
                  initialValue={[]}
                  options={process}
                  label="عملیات"
                />
              </Grid>
              <Grid md={4} xs={8}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterJalaali}>
                    <DatePicker
                      value={predictionDate}
                      onChange={(date) => setPredictionDate(date)}
                      // disablePast={true}
                      label="پیش بینی خروج"
                      disableMaskedInput
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size={"medium"}
                          variant={"outlined"}
                          disabled={wait}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid md={2} xs={4}>
                <FormControlLabel
                  sx={{ justifyContent: "start" }}
                  control={<Checkbox value={wait} onChange={waitHandler} />}
                  label="در انتظار"
                />
              </Grid>
              <Grid md={12} xs={12}>
                <Input
                  id="description"
                  element="input"
                  label="توضیحات شروع کار"
                  validators={[VALIDATOR_VALIDATED()]}
                  multiline={true}
                  onInput={inputHandler}
                  inputValid={true}
                />
              </Grid>
              <Grid xs={12} sm={12}>
                <Button
                  type="submit"
                  disabled={
                    !formState.isValid ||
                    startDate == null ||
                    predictionDate == null
                  }
                  fullWidth
                  color="secondary"
                  variant="contained"
                >
                  ثبت سفارش جدید
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Paper>
    </React.Fragment>
  );
};

export default NewOrderForm;
